const getDegreesFromString = (transformValue) =>
  Number(transformValue.replace('rotate(', '').replace('deg)', ''));

export default getDegreesFromString;
